import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AssetGridComponent } from "./shared/components/asset-grid/asset-grid.component";
import { AssetListComponent } from "./shared/components/asset-list/asset-list.component";
import { ContactListComponent } from "./shared/components/contact-list/contact-list.component";
import { SupportListComponent } from "./shared/components/support-list/support-list.component";
import { SupportGridComponent } from "./shared/components/support.grid/support-grid.component";
import { CvePipe } from "./shared/pipes/cve.pipe";
import { Linkify } from "./shared/pipes/linkify.pipe";
import { RemoveWhiteSpacePipe } from "./shared/pipes/removewhitespace.pipe";
import { SafeHTML } from "./shared/pipes/safeHtml";
import { SignalPipe } from "./shared/pipes/signal.pipe";
import { StatFilter } from "./shared/pipes/statFilter";
import { UploadFilesComponent } from "./shared/components/upload-files/upload-files.component"
import { ReactiveFormsModule } from '@angular/forms';
import { ReplacePipe } from "./shared/pipes/replace";
import { HelpComponent } from "./shared/components/help/help.component";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  let translationsVersion = environment.translationsVersion || new Date();
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?ver=' + translationsVersion);
}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
      }
    }),
    FontAwesomeModule,
    RouterModule,
    ReactiveFormsModule,
    NgbModule
  ],
  declarations: [ 
    SafeHTML,
    StatFilter,
    Linkify,
    SignalPipe,
    CvePipe,
    ReplacePipe,
    RemoveWhiteSpacePipe,
    SupportGridComponent,
    SupportListComponent,
    AssetListComponent,
    ContactListComponent,
    AssetGridComponent,
    UploadFilesComponent,
    HelpComponent
  ],
  exports: [
    TranslateModule,
    SafeHTML,
    StatFilter,
    Linkify,
    SignalPipe,
    ReplacePipe,
    CvePipe,
    RemoveWhiteSpacePipe,
    SupportGridComponent,
    SupportListComponent,
    AssetListComponent,
    ContactListComponent,
    AssetGridComponent,
    HelpComponent,
    CommonModule,
    TranslateModule,
    FontAwesomeModule,
    RouterModule,
    UploadFilesComponent,
    ReactiveFormsModule
  ],
  entryComponents: [
  ]
})
export class AppSharedModule {
}